export const getAutoshipLabel = (nextSubscriptionDate: Maybe<string>) => {
    if (!nextSubscriptionDate) return 'Add to next Autoship order';

    const date = new Date(nextSubscriptionDate);

    if (Number.isNaN(date.getTime())) return 'Add to next Autoship order';

    const formattedDate = date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        weekday: 'short',
        timeZone: 'UTC',
    });

    return `Add to ${formattedDate} order`;
};
